"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _fiverReactUiComponents = require("fiver-react-ui-components");

var _jsxRuntime = require("react/jsx-runtime");

var _templateObject, _templateObject2, _templateObject3, _templateObject4;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var StyledWrapper = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: fit-content;\n  margin: 0 auto;\n"])));

var StyledButton = _styledComponents.default.a(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  /* position: absolute;\n  right: 0;\n  top: 0; */\n  padding: 0 1.2rem 1rem;\n  color: ", ";\n  background: ", ";\n  border-radius: 0.5rem;\n  display: none;\n  margin: 0 auto 3rem;\n  width: auto;\n\n  @media only screen and (max-width: ", ") {\n    display: flex;\n  }\n"])), function (p) {
  return p.theme.colorText;
}, function (p) {
  return p.theme.colorShareButton;
}, function (props) {
  return props.theme.screenWidthXs;
});

var StyledIcon = (0, _styledComponents.default)(_fiverReactUiComponents.MatIcon)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  color: ", ";\n  padding: 1rem 0 0;\n"])), function (p) {
  return p.theme.colorText;
});

var StyledText = _styledComponents.default.p(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  padding: 1.2rem 0 0 0.1rem;\n  margin: 0;\n"])));

var Wrapper = function Wrapper(_ref) {
  var translations = _ref.translations;
  // const handleClick = (e) => {
  //   e.preventDefault();
  //   if (navigator.share) {
  //     navigator
  //       .share({
  //         title: `${process.env.REACT_APP_TITLE}`,
  //         text: `I have answered 6 questions about NED DUI that will make me win 10k. Beat me!`,
  //         url: document.location.href,
  //       })
  //       .then(() => {
  //         console.log("Successfully shared");
  //       })
  //       .catch((error) => {
  //         console.error("Something went wrong sharing the blog", error);
  //       });
  //   }
  // };
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledWrapper, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)(StyledButton, {
      href: "whatsapp://send?text=".concat(translations.shareMessage, " ").concat(window.location.href),
      "data-action": "share/whatsapp/share",
      target: "_blank",
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StyledIcon, {
        children: "whatsapp"
      }), /*#__PURE__*/(0, _jsxRuntime.jsx)(StyledText, {
        children: translations.share
      })]
    })
  });
};

var _default = Wrapper;
exports.default = _default;